import { Box, Typography, useTheme } from "@mui/material";
import { Receipt, MonitorWeight } from "@mui/icons-material";
import { ReactNode } from "react";
import pluralize from "pluralize";
import { formatNumber } from "../../constants/utils";
import PalletsIcon from "./icons/PalletsIcon";
import PiecesIcon from "./icons/PiecesIcon";
import { iconFillColors } from "./icons/Icon.types";
import type { LoadSummary } from "./EquipmentDropdown.types";

const iconStyles = { fontSize: "1.25rem", color: iconFillColors.darkGray };

const loadMetricIcons = {
  bills: <Receipt sx={iconStyles} />,
  pallets: <PalletsIcon sx={iconStyles} />,
  pieces: <PiecesIcon sx={iconStyles} />,
  weight: <MonitorWeight sx={iconStyles} />,
};

const MetricDisplay = ({
  icon,
  value,
  unit,
}: {
  icon: ReactNode;
  value: number;
  unit: string;
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", gap: "4px" }}
      aria-label={`${unit} ${value}`}
    >
      {icon}
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 400,
          color: theme.palette.grey[500],
          lineHeight: "20px",
        }}
      >
        {formatNumber(value)} {pluralize(unit, value)}
      </Typography>
    </Box>
  );
};

export const LoadSummaryDisplay = ({
  loadSummary,
}: {
  loadSummary: LoadSummary;
}) => {
  const { bills, pallets, pieces, weight } = loadSummary;

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <MetricDisplay icon={loadMetricIcons.bills} value={bills} unit="Bill" />
      <MetricDisplay
        icon={loadMetricIcons.pallets}
        value={pallets}
        unit="Pallet"
      />
      <MetricDisplay
        icon={loadMetricIcons.pieces}
        value={pieces}
        unit="Piece"
      />
      <MetricDisplay icon={loadMetricIcons.weight} value={weight} unit="lb" />
    </Box>
  );
};
